import React from 'react';

import { ClaimDocumentMetadata } from '~/components/Chat/types';
import { ClaimItemBase } from '~/components/Claim/types';
import OkIcon from '~/core/iconComponents/icons/OkIcon.tsx';
import type { IconProps } from '~/core/iconComponents/types';
import { parseDateWithOptionalTimezone, toTimeAgo } from '~/utils/Dates/DateTimeUtils';

export const getDocumentIcon = (): React.ComponentType<IconProps> => {
  return OkIcon;
};

export const documentToClaimItem = (document: ClaimDocumentMetadata): ClaimItemBase => {
  return {
    id: document.id,
    type: 'document',
    claim_number: '', // Not available in document metadata
    title: document.document_name || 'Unnamed Document',
    content: document.document_full_summary || document.document_summary || 'Document content not available',
    created_at: document.upload_date,
    updated_at: document.upload_date,
    metadata: {
      document_type: document.document_type,
      file_type: document.file_type,
      is_translated: document.is_translated,
    },
  };
};

export const documentToListItem = (document: ClaimItemBase) => {
  const IconComponent = getDocumentIcon();

  const timeAgo = document.updated_at ? toTimeAgo(parseDateWithOptionalTimezone(document.updated_at)) : '';

  return {
    id: document.id,
    content: (
      <div className="flex w-full items-center pr-8">
        <div>{document.title}</div>
        <div className="ml-auto bg-clip-text text-sm font-normal text-transparent">{timeAgo}</div>
      </div>
    ),
    icon: (
      <div className="flex items-center justify-center rounded-lg bg-blue-100 p-4">
        <IconComponent
          size={16}
          className="rounded-full border-1 border-blue-600 bg-blue-600/10 stroke-[1.5] p-2 text-blue-600"
        />
      </div>
    ),
  };
};

export const sortDocuments = (documents: ClaimDocumentMetadata[] = []) => {
  return [...documents].sort((a, b) => {
    if (a.upload_date && b.upload_date) {
      return new Date(b.upload_date).getTime() - new Date(a.upload_date).getTime();
    }

    // Handle cases where upload_date might be undefined
    if (a.upload_date && !b.upload_date) return -1;
    if (!a.upload_date && b.upload_date) return 1;

    return 0;
  });
};
